import React, { useEffect } from "react";
import LoadingSpinner from "../components/LoadingSpinner";

const index = () => {
  useEffect(() => {
    window.location.replace("http://hibbertgroup-maintenance.com");
  }, []);

  return <LoadingSpinner />;
};

export default index;
